import React from "react";

import * as S from './styles'
import { useFetchContent } from "src/hooks/useContentful/useFetchContent";
import Loading from "src/components/Loading";

function RecargaAutomatica() {
  const { data, isLoading } = useFetchContent();

  if (isLoading || !data) return <Loading />;


  return (
    <S.Container>
      <S.TitleContent>
          <h1>Sua recarga no automático</h1>
          <h2>Mantenha seu saldo atualizado e passe direto por pedágios e filas de estacionamento</h2>
      </S.TitleContent>
      <S.BodyContent>
        <S.Topics>
          <S.Item>
          <img src='/bradescoclassic/assets/check.svg' alt='check' />
            <span>Recargas automáticas após consumo de 70% do saldo total*;</span>
          </S.Item>
          <S.Item>
          <img src='/bradescoclassic/assets/check.svg' alt='check' />
            <span>Recargas manuais ilimitadas, de acordo com sua necessidade;</span>
          </S.Item>
          <S.Item>
            <img src='/bradescoclassic/assets/check.svg' alt='check' />
            <span>Recarregue a partir de R$50.</span>
          </S.Item>
          </S.Topics>
        <S.TextIntro>*Recargas automáticas serão realizadas, desde que exista saldo disponível no cartão cadastrado</S.TextIntro>
      </S.BodyContent>
    </S.Container>
  );
}

export default RecargaAutomatica;
